const size = {
  mobileS: '375px',
  mobile: '480px',
  tablet: '768px',
  laptop: '1024px',
  desktop: '1440px'
};

export const device = {
  mobileS: `@media screen and (min-width: ${size.mobileS})`,
  mobile: `@media screen and (min-width: ${size.mobile})`,
  tablet: `@media screen and (min-width: ${size.tablet})`,
  laptop: `@media screen and (min-width: ${size.laptop})`,
  desktop: `@media screen and (min-width: ${size.desktop})`,
  // Max-width queries for mobile-specific overrides
  maxMobile: `@media screen and (max-width: ${size.mobile})`,
  maxTablet: `@media screen and (max-width: ${size.tablet})`,
};